import { IPhanLopChuyenNganhActionTypes } from "../../action-types/phan-lop-chuyen-nganh/IPhanLopChuyenNganhActions";
import { IPhanLopChuyenNganhReducer } from "../../reducer-model/phan-lop-chuyen-nganh/IPhanLopChuyenNganhReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const initState: IPhanLopChuyenNganhReducer = {
  currentTab: "chot-du-lieu",

  filterChot: { id_he: 0, khoa_hoc: 0, nam_hoc: "", hoc_ky: 0 },
  trangThaiStatus: eReducerStatusBase.is_not_initialization,
  trangThais: [],

  filterQd: { nam_hoc: "", hoc_ky: 0 },
  quyetDinhStatus: eReducerStatusBase.is_not_initialization,
  quyetDinhs: [],
  currentQdId: 0,

  chiTietStatus: eReducerStatusBase.is_not_initialization,
  chiTiets: [],

  ketQuas: [],
  isProcessing: false,
};

export const phanLopChuyenNganhReducer = (
  state: IPhanLopChuyenNganhReducer = initState,
  action: IPhanLopChuyenNganhActionTypes
): IPhanLopChuyenNganhReducer => {
  switch (action.type) {
    case "PHAN_LOP_CHUYEN_NGANH_CHANGE_TAB":
      return { ...state, currentTab: action.payload };

    // ---------------- Tab A ----------------
    case "PHAN_LOP_CHUYEN_NGANH_CHANGE_FILTER_CHOT":
      return {
        ...state,
        filterChot: action.payload,
        trangThaiStatus: eReducerStatusBase.is_need_reload,
      };

    case "PHAN_LOP_CHUYEN_NGANH_LOAD_TRANG_THAIS_START":
      return { ...state, trangThaiStatus: eReducerStatusBase.is_loading };
    case "PHAN_LOP_CHUYEN_NGANH_LOAD_TRANG_THAIS_SUCCESS":
      return { ...state, trangThaiStatus: eReducerStatusBase.is_completed, trangThais: action.payload };
    case "PHAN_LOP_CHUYEN_NGANH_LOAD_TRANG_THAIS_ERRR":
      return { ...state, trangThaiStatus: eReducerStatusBase.is_completed };

    case "PHAN_LOP_CHUYEN_NGANH_CHOT_START":
      return { ...state, isProcessing: true };
    case "PHAN_LOP_CHUYEN_NGANH_CHOT_SUCCESS":
      return { ...state, isProcessing: false, trangThaiStatus: eReducerStatusBase.is_need_reload };
    case "PHAN_LOP_CHUYEN_NGANH_CHOT_ERRR":
      return { ...state, isProcessing: false };

    case "PHAN_LOP_CHUYEN_NGANH_SET_LOCK_START":
    case "PHAN_LOP_CHUYEN_NGANH_DELETE_CHOTS_START":
      return { ...state, isProcessing: true };
    case "PHAN_LOP_CHUYEN_NGANH_SET_LOCK_SUCCESS":
    case "PHAN_LOP_CHUYEN_NGANH_DELETE_CHOTS_SUCCESS":
      return { ...state, isProcessing: false, trangThaiStatus: eReducerStatusBase.is_need_reload };
    case "PHAN_LOP_CHUYEN_NGANH_SET_LOCK_ERRR":
    case "PHAN_LOP_CHUYEN_NGANH_DELETE_CHOTS_ERRR":
      return { ...state, isProcessing: false };

    // ---------------- Tab B ----------------
    case "PHAN_LOP_CHUYEN_NGANH_CHANGE_FILTER_QD":
      return {
        ...state,
        filterQd: action.payload,
        quyetDinhStatus: eReducerStatusBase.is_need_reload,
        currentQdId: 0,
        chiTiets: [],
        chiTietStatus: eReducerStatusBase.is_not_initialization,
      };

    case "PHAN_LOP_CHUYEN_NGANH_CHANGE_CURRENT_QD":
      return {
        ...state,
        currentQdId: action.payload,
        chiTiets: [],
        chiTietStatus: action.payload > 0
          ? eReducerStatusBase.is_need_reload
          : eReducerStatusBase.is_not_initialization,
      };

    case "PHAN_LOP_CHUYEN_NGANH_LOAD_QUYET_DINHS_START":
      return { ...state, quyetDinhStatus: eReducerStatusBase.is_loading };
    case "PHAN_LOP_CHUYEN_NGANH_LOAD_QUYET_DINHS_SUCCESS":
      return { ...state, quyetDinhStatus: eReducerStatusBase.is_completed, quyetDinhs: action.payload };
    case "PHAN_LOP_CHUYEN_NGANH_LOAD_QUYET_DINHS_ERRR":
      return { ...state, quyetDinhStatus: eReducerStatusBase.is_completed };

    case "PHAN_LOP_CHUYEN_NGANH_SHOW_EDIT_MODAL":
      return { ...state, isShowEditModal: true, qdEditing: action.payload };
    case "PHAN_LOP_CHUYEN_NGANH_CLOSE_EDIT_MODAL":
      return { ...state, isShowEditModal: false };

    case "PHAN_LOP_CHUYEN_NGANH_SAVE_QUYET_DINH_START":
      return { ...state, isProcessing: true };
    case "PHAN_LOP_CHUYEN_NGANH_SAVE_QUYET_DINH_SUCCESS":
      return {
        ...state,
        isProcessing: false,
        isShowEditModal: false,
        quyetDinhStatus: eReducerStatusBase.is_need_reload,
      };
    case "PHAN_LOP_CHUYEN_NGANH_SAVE_QUYET_DINH_ERRR":
      return { ...state, isProcessing: false };

    case "PHAN_LOP_CHUYEN_NGANH_DELETE_QUYET_DINH_START":
      return { ...state, isProcessing: true };
    case "PHAN_LOP_CHUYEN_NGANH_DELETE_QUYET_DINH_SUCCESS":
      return {
        ...state,
        isProcessing: false,
        currentQdId: 0,
        chiTiets: [],
        quyetDinhStatus: eReducerStatusBase.is_need_reload,
      };
    case "PHAN_LOP_CHUYEN_NGANH_DELETE_QUYET_DINH_ERRR":
      return { ...state, isProcessing: false };

    case "PHAN_LOP_CHUYEN_NGANH_LOAD_CHI_TIETS_START":
      return { ...state, chiTietStatus: eReducerStatusBase.is_loading };
    case "PHAN_LOP_CHUYEN_NGANH_LOAD_CHI_TIETS_SUCCESS":
      return { ...state, chiTietStatus: eReducerStatusBase.is_completed, chiTiets: action.payload };
    case "PHAN_LOP_CHUYEN_NGANH_LOAD_CHI_TIETS_ERRR":
      return { ...state, chiTietStatus: eReducerStatusBase.is_completed };

    // Các thao tác ghi theo từng sinh viên: đều mở modal kết quả và reload cả 2 lưới
    case "PHAN_LOP_CHUYEN_NGANH_ADD_CHI_TIETS_START":
    case "PHAN_LOP_CHUYEN_NGANH_UPDATE_LOP_MOI_START":
    case "PHAN_LOP_CHUYEN_NGANH_CHUYEN_LOP_START":
    case "PHAN_LOP_CHUYEN_NGANH_THU_HOI_START":
      return { ...state, isProcessing: true };

    case "PHAN_LOP_CHUYEN_NGANH_ADD_CHI_TIETS_SUCCESS":
      return {
        ...state,
        isProcessing: false,
        ketQuas: action.payload ?? [],
        isShowKetQuaModal: true,
        ketQuaTitle: "Kết quả thêm sinh viên",
        chiTietStatus: eReducerStatusBase.is_need_reload,
        quyetDinhStatus: eReducerStatusBase.is_need_reload,
      };
    case "PHAN_LOP_CHUYEN_NGANH_UPDATE_LOP_MOI_SUCCESS":
      return {
        ...state,
        isProcessing: false,
        ketQuas: action.payload ?? [],
        isShowKetQuaModal: true,
        ketQuaTitle: "Kết quả đổi lớp chuyển",
        chiTietStatus: eReducerStatusBase.is_need_reload,
        quyetDinhStatus: eReducerStatusBase.is_need_reload,
      };
    case "PHAN_LOP_CHUYEN_NGANH_CHUYEN_LOP_SUCCESS":
      return {
        ...state,
        isProcessing: false,
        ketQuas: action.payload ?? [],
        isShowKetQuaModal: true,
        ketQuaTitle: "Kết quả chuyển lớp",
        chiTietStatus: eReducerStatusBase.is_need_reload,
        quyetDinhStatus: eReducerStatusBase.is_need_reload,
        trangThaiStatus: eReducerStatusBase.is_need_reload,
      };
    case "PHAN_LOP_CHUYEN_NGANH_THU_HOI_SUCCESS":
      return {
        ...state,
        isProcessing: false,
        ketQuas: action.payload ?? [],
        isShowKetQuaModal: true,
        ketQuaTitle: "Kết quả thu hồi",
        chiTietStatus: eReducerStatusBase.is_need_reload,
        quyetDinhStatus: eReducerStatusBase.is_need_reload,
        trangThaiStatus: eReducerStatusBase.is_need_reload,
      };

    case "PHAN_LOP_CHUYEN_NGANH_ADD_CHI_TIETS_ERRR":
    case "PHAN_LOP_CHUYEN_NGANH_UPDATE_LOP_MOI_ERRR":
    case "PHAN_LOP_CHUYEN_NGANH_CHUYEN_LOP_ERRR":
    case "PHAN_LOP_CHUYEN_NGANH_THU_HOI_ERRR":
      return { ...state, isProcessing: false };

    case "PHAN_LOP_CHUYEN_NGANH_CLOSE_KET_QUA_MODAL":
      return { ...state, isShowKetQuaModal: false, ketQuas: [] };

    default:
      return state;
  }
};
